/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LeaidRouteRouteImport } from './routes/$leaid/route'
import { Route as DefaultRouteRouteImport } from './routes/_default/route'
import { Route as TermsConditionsRouteImport } from './routes/terms-conditions'
import { Route as LeaidErrorWrapperRouteRouteImport } from './routes/$leaid/_error-wrapper/route'
import { Route as DefaultIndexRouteImport } from './routes/_default/index'
import { Route as LeaidErrorWrapperIndexRouteImport } from './routes/$leaid/_error-wrapper/index'
import { Route as LeaidErrorWrapperDiscrepanciesRouteImport } from './routes/$leaid/_error-wrapper/discrepancies'
import { Route as LeaidErrorWrapperExportsRouteImport } from './routes/$leaid/_error-wrapper/exports'
import { Route as LeaidErrorWrapperMatchToolRouteImport } from './routes/$leaid/_error-wrapper/match-tool'
import { Route as LeaidErrorWrapperProfileRouteImport } from './routes/$leaid/_error-wrapper/profile'
import { Route as LeaidErrorWrapperUploadRouteImport } from './routes/$leaid/_error-wrapper/upload'
import { Route as LeaidErrorWrapperAdminCalpadsSyncRouteImport } from './routes/$leaid/_error-wrapper/admin/calpads-sync'
import { Route as LeaidErrorWrapperAdminChildDataViewRouteImport } from './routes/$leaid/_error-wrapper/admin/child-data-view'
import { Route as LeaidErrorWrapperAdminLeaDataViewRouteImport } from './routes/$leaid/_error-wrapper/admin/lea-data-view'
import { Route as LeaidErrorWrapperAdminReportsRouteImport } from './routes/$leaid/_error-wrapper/admin/reports'
import { Route as LeaidErrorWrapperAdminStateLevelDataViewRouteImport } from './routes/$leaid/_error-wrapper/admin/state-level-data-view'
import { Route as LeaidErrorWrapperAdminSystemMessagesRouteImport } from './routes/$leaid/_error-wrapper/admin/system-messages'
import { Route as LeaidErrorWrapperCertificationCyclesIndexRouteImport } from './routes/$leaid/_error-wrapper/certification-cycles/index'
import { Route as LeaidErrorWrapperCertificationCyclesCertificationidRouteImport } from './routes/$leaid/_error-wrapper/certification-cycles/$certificationid'
import { Route as LeaidErrorWrapperMidIndexRouteImport } from './routes/$leaid/_error-wrapper/mid/index'
import { Route as LeaidErrorWrapperMidMidRouteImport } from './routes/$leaid/_error-wrapper/mid/$mid'
import { Route as LeaidErrorWrapperRecordsLocalDataRouteImport } from './routes/$leaid/_error-wrapper/records/local-data'
import { Route as LeaidErrorWrapperRecordsQuickSearchRouteImport } from './routes/$leaid/_error-wrapper/records/quick-search'
import { Route as LeaidErrorWrapperReportsIndexRouteImport } from './routes/$leaid/_error-wrapper/reports/index'
import { Route as LeaidErrorWrapperReportsReporttypeRouteImport } from './routes/$leaid/_error-wrapper/reports/$reporttype'
import { Route as LeaidErrorWrapperSubmissionsIndexRouteImport } from './routes/$leaid/_error-wrapper/submissions/index'
import { Route as LeaidErrorWrapperAdminSiteAdministrationAnomaliesRouteImport } from './routes/$leaid/_error-wrapper/admin/site-administration/anomalies'
import { Route as LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRouteImport } from './routes/$leaid/_error-wrapper/admin/site-administration/feature-flags'
import { Route as LeaidErrorWrapperAdminUsersIndexRouteImport } from './routes/$leaid/_error-wrapper/admin/users/index'
import { Route as LeaidErrorWrapperAdminUsersUseridRouteImport } from './routes/$leaid/_error-wrapper/admin/users/$userid'
import { Route as LeaidErrorWrapperRecordsAttendanceIndexRouteImport } from './routes/$leaid/_error-wrapper/records/attendance/index'
import { Route as LeaidErrorWrapperRecordsChildIndexRouteImport } from './routes/$leaid/_error-wrapper/records/child/index'
import { Route as LeaidErrorWrapperRecordsChildEntityidRouteImport } from './routes/$leaid/_error-wrapper/records/child/$entityid'
import { Route as LeaidErrorWrapperRecordsClassroomIndexRouteImport } from './routes/$leaid/_error-wrapper/records/classroom/index'
import { Route as LeaidErrorWrapperRecordsClassroomEntityidRouteImport } from './routes/$leaid/_error-wrapper/records/classroom/$entityid'
import { Route as LeaidErrorWrapperRecordsStaffIndexRouteImport } from './routes/$leaid/_error-wrapper/records/staff/index'
import { Route as LeaidErrorWrapperRecordsStaffStaffIdRouteImport } from './routes/$leaid/_error-wrapper/records/staff/$staffId'

const LeaidRouteRoute = LeaidRouteRouteImport.update({
  id: '/$leaid',
  path: '/$leaid',
  getParentRoute: () => rootRouteImport,
} as any)
const DefaultRouteRoute = DefaultRouteRouteImport.update({
  id: '/_default',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsConditionsRoute = TermsConditionsRouteImport.update({
  id: '/terms-conditions',
  path: '/terms-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaidErrorWrapperRouteRoute = LeaidErrorWrapperRouteRouteImport.update({
  id: '/_error-wrapper',
  getParentRoute: () => LeaidRouteRoute,
} as any)
const DefaultIndexRoute = DefaultIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DefaultRouteRoute,
} as any)
const LeaidErrorWrapperIndexRoute = LeaidErrorWrapperIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LeaidErrorWrapperRouteRoute,
} as any)
const LeaidErrorWrapperDiscrepanciesRoute =
  LeaidErrorWrapperDiscrepanciesRouteImport.update({
    id: '/discrepancies',
    path: '/discrepancies',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperExportsRoute =
  LeaidErrorWrapperExportsRouteImport.update({
    id: '/exports',
    path: '/exports',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperMatchToolRoute =
  LeaidErrorWrapperMatchToolRouteImport.update({
    id: '/match-tool',
    path: '/match-tool',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperProfileRoute =
  LeaidErrorWrapperProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperUploadRoute = LeaidErrorWrapperUploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => LeaidErrorWrapperRouteRoute,
} as any)
const LeaidErrorWrapperAdminCalpadsSyncRoute =
  LeaidErrorWrapperAdminCalpadsSyncRouteImport.update({
    id: '/admin/calpads-sync',
    path: '/admin/calpads-sync',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminChildDataViewRoute =
  LeaidErrorWrapperAdminChildDataViewRouteImport.update({
    id: '/admin/child-data-view',
    path: '/admin/child-data-view',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminLeaDataViewRoute =
  LeaidErrorWrapperAdminLeaDataViewRouteImport.update({
    id: '/admin/lea-data-view',
    path: '/admin/lea-data-view',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminReportsRoute =
  LeaidErrorWrapperAdminReportsRouteImport.update({
    id: '/admin/reports',
    path: '/admin/reports',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminStateLevelDataViewRoute =
  LeaidErrorWrapperAdminStateLevelDataViewRouteImport.update({
    id: '/admin/state-level-data-view',
    path: '/admin/state-level-data-view',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminSystemMessagesRoute =
  LeaidErrorWrapperAdminSystemMessagesRouteImport.update({
    id: '/admin/system-messages',
    path: '/admin/system-messages',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperCertificationCyclesIndexRoute =
  LeaidErrorWrapperCertificationCyclesIndexRouteImport.update({
    id: '/certification-cycles/',
    path: '/certification-cycles/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperCertificationCyclesCertificationidRoute =
  LeaidErrorWrapperCertificationCyclesCertificationidRouteImport.update({
    id: '/certification-cycles/$certificationid',
    path: '/certification-cycles/$certificationid',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperMidIndexRoute =
  LeaidErrorWrapperMidIndexRouteImport.update({
    id: '/mid/',
    path: '/mid/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperMidMidRoute = LeaidErrorWrapperMidMidRouteImport.update({
  id: '/mid/$mid',
  path: '/mid/$mid',
  getParentRoute: () => LeaidErrorWrapperRouteRoute,
} as any)
const LeaidErrorWrapperRecordsLocalDataRoute =
  LeaidErrorWrapperRecordsLocalDataRouteImport.update({
    id: '/records/local-data',
    path: '/records/local-data',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsQuickSearchRoute =
  LeaidErrorWrapperRecordsQuickSearchRouteImport.update({
    id: '/records/quick-search',
    path: '/records/quick-search',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperReportsIndexRoute =
  LeaidErrorWrapperReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperReportsReporttypeRoute =
  LeaidErrorWrapperReportsReporttypeRouteImport.update({
    id: '/reports/$reporttype',
    path: '/reports/$reporttype',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperSubmissionsIndexRoute =
  LeaidErrorWrapperSubmissionsIndexRouteImport.update({
    id: '/submissions/',
    path: '/submissions/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute =
  LeaidErrorWrapperAdminSiteAdministrationAnomaliesRouteImport.update({
    id: '/admin/site-administration/anomalies',
    path: '/admin/site-administration/anomalies',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute =
  LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRouteImport.update({
    id: '/admin/site-administration/feature-flags',
    path: '/admin/site-administration/feature-flags',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminUsersIndexRoute =
  LeaidErrorWrapperAdminUsersIndexRouteImport.update({
    id: '/admin/users/',
    path: '/admin/users/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperAdminUsersUseridRoute =
  LeaidErrorWrapperAdminUsersUseridRouteImport.update({
    id: '/admin/users/$userid',
    path: '/admin/users/$userid',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsAttendanceIndexRoute =
  LeaidErrorWrapperRecordsAttendanceIndexRouteImport.update({
    id: '/records/attendance/',
    path: '/records/attendance/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsChildIndexRoute =
  LeaidErrorWrapperRecordsChildIndexRouteImport.update({
    id: '/records/child/',
    path: '/records/child/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsChildEntityidRoute =
  LeaidErrorWrapperRecordsChildEntityidRouteImport.update({
    id: '/records/child/$entityid',
    path: '/records/child/$entityid',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsClassroomIndexRoute =
  LeaidErrorWrapperRecordsClassroomIndexRouteImport.update({
    id: '/records/classroom/',
    path: '/records/classroom/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsClassroomEntityidRoute =
  LeaidErrorWrapperRecordsClassroomEntityidRouteImport.update({
    id: '/records/classroom/$entityid',
    path: '/records/classroom/$entityid',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsStaffIndexRoute =
  LeaidErrorWrapperRecordsStaffIndexRouteImport.update({
    id: '/records/staff/',
    path: '/records/staff/',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)
const LeaidErrorWrapperRecordsStaffStaffIdRoute =
  LeaidErrorWrapperRecordsStaffStaffIdRouteImport.update({
    id: '/records/staff/$staffId',
    path: '/records/staff/$staffId',
    getParentRoute: () => LeaidErrorWrapperRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$leaid': typeof LeaidRouteRouteWithChildren
  '/': typeof DefaultIndexRoute
  '/terms-conditions': typeof TermsConditionsRoute
  '/$leaid/discrepancies': typeof LeaidErrorWrapperDiscrepanciesRoute
  '/$leaid/exports': typeof LeaidErrorWrapperExportsRoute
  '/$leaid/match-tool': typeof LeaidErrorWrapperMatchToolRoute
  '/$leaid/profile': typeof LeaidErrorWrapperProfileRoute
  '/$leaid/upload': typeof LeaidErrorWrapperUploadRoute
  '/$leaid/': typeof LeaidErrorWrapperIndexRoute
  '/$leaid/admin/calpads-sync': typeof LeaidErrorWrapperAdminCalpadsSyncRoute
  '/$leaid/admin/child-data-view': typeof LeaidErrorWrapperAdminChildDataViewRoute
  '/$leaid/admin/lea-data-view': typeof LeaidErrorWrapperAdminLeaDataViewRoute
  '/$leaid/admin/reports': typeof LeaidErrorWrapperAdminReportsRoute
  '/$leaid/admin/state-level-data-view': typeof LeaidErrorWrapperAdminStateLevelDataViewRoute
  '/$leaid/admin/system-messages': typeof LeaidErrorWrapperAdminSystemMessagesRoute
  '/$leaid/certification-cycles/$certificationid': typeof LeaidErrorWrapperCertificationCyclesCertificationidRoute
  '/$leaid/mid/$mid': typeof LeaidErrorWrapperMidMidRoute
  '/$leaid/records/local-data': typeof LeaidErrorWrapperRecordsLocalDataRoute
  '/$leaid/records/quick-search': typeof LeaidErrorWrapperRecordsQuickSearchRoute
  '/$leaid/reports/$reporttype': typeof LeaidErrorWrapperReportsReporttypeRoute
  '/$leaid/certification-cycles/': typeof LeaidErrorWrapperCertificationCyclesIndexRoute
  '/$leaid/mid/': typeof LeaidErrorWrapperMidIndexRoute
  '/$leaid/reports/': typeof LeaidErrorWrapperReportsIndexRoute
  '/$leaid/submissions/': typeof LeaidErrorWrapperSubmissionsIndexRoute
  '/$leaid/admin/site-administration/anomalies': typeof LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute
  '/$leaid/admin/site-administration/feature-flags': typeof LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute
  '/$leaid/admin/users/$userid': typeof LeaidErrorWrapperAdminUsersUseridRoute
  '/$leaid/records/child/$entityid': typeof LeaidErrorWrapperRecordsChildEntityidRoute
  '/$leaid/records/classroom/$entityid': typeof LeaidErrorWrapperRecordsClassroomEntityidRoute
  '/$leaid/records/staff/$staffId': typeof LeaidErrorWrapperRecordsStaffStaffIdRoute
  '/$leaid/admin/users/': typeof LeaidErrorWrapperAdminUsersIndexRoute
  '/$leaid/records/attendance/': typeof LeaidErrorWrapperRecordsAttendanceIndexRoute
  '/$leaid/records/child/': typeof LeaidErrorWrapperRecordsChildIndexRoute
  '/$leaid/records/classroom/': typeof LeaidErrorWrapperRecordsClassroomIndexRoute
  '/$leaid/records/staff/': typeof LeaidErrorWrapperRecordsStaffIndexRoute
}
export interface FileRoutesByTo {
  '/$leaid': typeof LeaidErrorWrapperIndexRoute
  '/terms-conditions': typeof TermsConditionsRoute
  '/': typeof DefaultIndexRoute
  '/$leaid/discrepancies': typeof LeaidErrorWrapperDiscrepanciesRoute
  '/$leaid/exports': typeof LeaidErrorWrapperExportsRoute
  '/$leaid/match-tool': typeof LeaidErrorWrapperMatchToolRoute
  '/$leaid/profile': typeof LeaidErrorWrapperProfileRoute
  '/$leaid/upload': typeof LeaidErrorWrapperUploadRoute
  '/$leaid/admin/calpads-sync': typeof LeaidErrorWrapperAdminCalpadsSyncRoute
  '/$leaid/admin/child-data-view': typeof LeaidErrorWrapperAdminChildDataViewRoute
  '/$leaid/admin/lea-data-view': typeof LeaidErrorWrapperAdminLeaDataViewRoute
  '/$leaid/admin/reports': typeof LeaidErrorWrapperAdminReportsRoute
  '/$leaid/admin/state-level-data-view': typeof LeaidErrorWrapperAdminStateLevelDataViewRoute
  '/$leaid/admin/system-messages': typeof LeaidErrorWrapperAdminSystemMessagesRoute
  '/$leaid/certification-cycles/$certificationid': typeof LeaidErrorWrapperCertificationCyclesCertificationidRoute
  '/$leaid/mid/$mid': typeof LeaidErrorWrapperMidMidRoute
  '/$leaid/records/local-data': typeof LeaidErrorWrapperRecordsLocalDataRoute
  '/$leaid/records/quick-search': typeof LeaidErrorWrapperRecordsQuickSearchRoute
  '/$leaid/reports/$reporttype': typeof LeaidErrorWrapperReportsReporttypeRoute
  '/$leaid/certification-cycles': typeof LeaidErrorWrapperCertificationCyclesIndexRoute
  '/$leaid/mid': typeof LeaidErrorWrapperMidIndexRoute
  '/$leaid/reports': typeof LeaidErrorWrapperReportsIndexRoute
  '/$leaid/submissions': typeof LeaidErrorWrapperSubmissionsIndexRoute
  '/$leaid/admin/site-administration/anomalies': typeof LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute
  '/$leaid/admin/site-administration/feature-flags': typeof LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute
  '/$leaid/admin/users/$userid': typeof LeaidErrorWrapperAdminUsersUseridRoute
  '/$leaid/records/child/$entityid': typeof LeaidErrorWrapperRecordsChildEntityidRoute
  '/$leaid/records/classroom/$entityid': typeof LeaidErrorWrapperRecordsClassroomEntityidRoute
  '/$leaid/records/staff/$staffId': typeof LeaidErrorWrapperRecordsStaffStaffIdRoute
  '/$leaid/admin/users': typeof LeaidErrorWrapperAdminUsersIndexRoute
  '/$leaid/records/attendance': typeof LeaidErrorWrapperRecordsAttendanceIndexRoute
  '/$leaid/records/child': typeof LeaidErrorWrapperRecordsChildIndexRoute
  '/$leaid/records/classroom': typeof LeaidErrorWrapperRecordsClassroomIndexRoute
  '/$leaid/records/staff': typeof LeaidErrorWrapperRecordsStaffIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$leaid': typeof LeaidRouteRouteWithChildren
  '/_default': typeof DefaultRouteRouteWithChildren
  '/terms-conditions': typeof TermsConditionsRoute
  '/$leaid/_error-wrapper': typeof LeaidErrorWrapperRouteRouteWithChildren
  '/_default/': typeof DefaultIndexRoute
  '/$leaid/_error-wrapper/discrepancies': typeof LeaidErrorWrapperDiscrepanciesRoute
  '/$leaid/_error-wrapper/exports': typeof LeaidErrorWrapperExportsRoute
  '/$leaid/_error-wrapper/match-tool': typeof LeaidErrorWrapperMatchToolRoute
  '/$leaid/_error-wrapper/profile': typeof LeaidErrorWrapperProfileRoute
  '/$leaid/_error-wrapper/upload': typeof LeaidErrorWrapperUploadRoute
  '/$leaid/_error-wrapper/': typeof LeaidErrorWrapperIndexRoute
  '/$leaid/_error-wrapper/admin/calpads-sync': typeof LeaidErrorWrapperAdminCalpadsSyncRoute
  '/$leaid/_error-wrapper/admin/child-data-view': typeof LeaidErrorWrapperAdminChildDataViewRoute
  '/$leaid/_error-wrapper/admin/lea-data-view': typeof LeaidErrorWrapperAdminLeaDataViewRoute
  '/$leaid/_error-wrapper/admin/reports': typeof LeaidErrorWrapperAdminReportsRoute
  '/$leaid/_error-wrapper/admin/state-level-data-view': typeof LeaidErrorWrapperAdminStateLevelDataViewRoute
  '/$leaid/_error-wrapper/admin/system-messages': typeof LeaidErrorWrapperAdminSystemMessagesRoute
  '/$leaid/_error-wrapper/certification-cycles/$certificationid': typeof LeaidErrorWrapperCertificationCyclesCertificationidRoute
  '/$leaid/_error-wrapper/mid/$mid': typeof LeaidErrorWrapperMidMidRoute
  '/$leaid/_error-wrapper/records/local-data': typeof LeaidErrorWrapperRecordsLocalDataRoute
  '/$leaid/_error-wrapper/records/quick-search': typeof LeaidErrorWrapperRecordsQuickSearchRoute
  '/$leaid/_error-wrapper/reports/$reporttype': typeof LeaidErrorWrapperReportsReporttypeRoute
  '/$leaid/_error-wrapper/certification-cycles/': typeof LeaidErrorWrapperCertificationCyclesIndexRoute
  '/$leaid/_error-wrapper/mid/': typeof LeaidErrorWrapperMidIndexRoute
  '/$leaid/_error-wrapper/reports/': typeof LeaidErrorWrapperReportsIndexRoute
  '/$leaid/_error-wrapper/submissions/': typeof LeaidErrorWrapperSubmissionsIndexRoute
  '/$leaid/_error-wrapper/admin/site-administration/anomalies': typeof LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute
  '/$leaid/_error-wrapper/admin/site-administration/feature-flags': typeof LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute
  '/$leaid/_error-wrapper/admin/users/$userid': typeof LeaidErrorWrapperAdminUsersUseridRoute
  '/$leaid/_error-wrapper/records/child/$entityid': typeof LeaidErrorWrapperRecordsChildEntityidRoute
  '/$leaid/_error-wrapper/records/classroom/$entityid': typeof LeaidErrorWrapperRecordsClassroomEntityidRoute
  '/$leaid/_error-wrapper/records/staff/$staffId': typeof LeaidErrorWrapperRecordsStaffStaffIdRoute
  '/$leaid/_error-wrapper/admin/users/': typeof LeaidErrorWrapperAdminUsersIndexRoute
  '/$leaid/_error-wrapper/records/attendance/': typeof LeaidErrorWrapperRecordsAttendanceIndexRoute
  '/$leaid/_error-wrapper/records/child/': typeof LeaidErrorWrapperRecordsChildIndexRoute
  '/$leaid/_error-wrapper/records/classroom/': typeof LeaidErrorWrapperRecordsClassroomIndexRoute
  '/$leaid/_error-wrapper/records/staff/': typeof LeaidErrorWrapperRecordsStaffIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$leaid'
    | '/'
    | '/terms-conditions'
    | '/$leaid/discrepancies'
    | '/$leaid/exports'
    | '/$leaid/match-tool'
    | '/$leaid/profile'
    | '/$leaid/upload'
    | '/$leaid/'
    | '/$leaid/admin/calpads-sync'
    | '/$leaid/admin/child-data-view'
    | '/$leaid/admin/lea-data-view'
    | '/$leaid/admin/reports'
    | '/$leaid/admin/state-level-data-view'
    | '/$leaid/admin/system-messages'
    | '/$leaid/certification-cycles/$certificationid'
    | '/$leaid/mid/$mid'
    | '/$leaid/records/local-data'
    | '/$leaid/records/quick-search'
    | '/$leaid/reports/$reporttype'
    | '/$leaid/certification-cycles/'
    | '/$leaid/mid/'
    | '/$leaid/reports/'
    | '/$leaid/submissions/'
    | '/$leaid/admin/site-administration/anomalies'
    | '/$leaid/admin/site-administration/feature-flags'
    | '/$leaid/admin/users/$userid'
    | '/$leaid/records/child/$entityid'
    | '/$leaid/records/classroom/$entityid'
    | '/$leaid/records/staff/$staffId'
    | '/$leaid/admin/users/'
    | '/$leaid/records/attendance/'
    | '/$leaid/records/child/'
    | '/$leaid/records/classroom/'
    | '/$leaid/records/staff/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$leaid'
    | '/terms-conditions'
    | '/'
    | '/$leaid/discrepancies'
    | '/$leaid/exports'
    | '/$leaid/match-tool'
    | '/$leaid/profile'
    | '/$leaid/upload'
    | '/$leaid/admin/calpads-sync'
    | '/$leaid/admin/child-data-view'
    | '/$leaid/admin/lea-data-view'
    | '/$leaid/admin/reports'
    | '/$leaid/admin/state-level-data-view'
    | '/$leaid/admin/system-messages'
    | '/$leaid/certification-cycles/$certificationid'
    | '/$leaid/mid/$mid'
    | '/$leaid/records/local-data'
    | '/$leaid/records/quick-search'
    | '/$leaid/reports/$reporttype'
    | '/$leaid/certification-cycles'
    | '/$leaid/mid'
    | '/$leaid/reports'
    | '/$leaid/submissions'
    | '/$leaid/admin/site-administration/anomalies'
    | '/$leaid/admin/site-administration/feature-flags'
    | '/$leaid/admin/users/$userid'
    | '/$leaid/records/child/$entityid'
    | '/$leaid/records/classroom/$entityid'
    | '/$leaid/records/staff/$staffId'
    | '/$leaid/admin/users'
    | '/$leaid/records/attendance'
    | '/$leaid/records/child'
    | '/$leaid/records/classroom'
    | '/$leaid/records/staff'
  id:
    | '__root__'
    | '/$leaid'
    | '/_default'
    | '/terms-conditions'
    | '/$leaid/_error-wrapper'
    | '/_default/'
    | '/$leaid/_error-wrapper/discrepancies'
    | '/$leaid/_error-wrapper/exports'
    | '/$leaid/_error-wrapper/match-tool'
    | '/$leaid/_error-wrapper/profile'
    | '/$leaid/_error-wrapper/upload'
    | '/$leaid/_error-wrapper/'
    | '/$leaid/_error-wrapper/admin/calpads-sync'
    | '/$leaid/_error-wrapper/admin/child-data-view'
    | '/$leaid/_error-wrapper/admin/lea-data-view'
    | '/$leaid/_error-wrapper/admin/reports'
    | '/$leaid/_error-wrapper/admin/state-level-data-view'
    | '/$leaid/_error-wrapper/admin/system-messages'
    | '/$leaid/_error-wrapper/certification-cycles/$certificationid'
    | '/$leaid/_error-wrapper/mid/$mid'
    | '/$leaid/_error-wrapper/records/local-data'
    | '/$leaid/_error-wrapper/records/quick-search'
    | '/$leaid/_error-wrapper/reports/$reporttype'
    | '/$leaid/_error-wrapper/certification-cycles/'
    | '/$leaid/_error-wrapper/mid/'
    | '/$leaid/_error-wrapper/reports/'
    | '/$leaid/_error-wrapper/submissions/'
    | '/$leaid/_error-wrapper/admin/site-administration/anomalies'
    | '/$leaid/_error-wrapper/admin/site-administration/feature-flags'
    | '/$leaid/_error-wrapper/admin/users/$userid'
    | '/$leaid/_error-wrapper/records/child/$entityid'
    | '/$leaid/_error-wrapper/records/classroom/$entityid'
    | '/$leaid/_error-wrapper/records/staff/$staffId'
    | '/$leaid/_error-wrapper/admin/users/'
    | '/$leaid/_error-wrapper/records/attendance/'
    | '/$leaid/_error-wrapper/records/child/'
    | '/$leaid/_error-wrapper/records/classroom/'
    | '/$leaid/_error-wrapper/records/staff/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LeaidRouteRoute: typeof LeaidRouteRouteWithChildren
  DefaultRouteRoute: typeof DefaultRouteRouteWithChildren
  TermsConditionsRoute: typeof TermsConditionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$leaid': {
      id: '/$leaid'
      path: '/$leaid'
      fullPath: '/$leaid'
      preLoaderRoute: typeof LeaidRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_default': {
      id: '/_default'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DefaultRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-conditions': {
      id: '/terms-conditions'
      path: '/terms-conditions'
      fullPath: '/terms-conditions'
      preLoaderRoute: typeof TermsConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$leaid/_error-wrapper': {
      id: '/$leaid/_error-wrapper'
      path: ''
      fullPath: '/$leaid'
      preLoaderRoute: typeof LeaidErrorWrapperRouteRouteImport
      parentRoute: typeof LeaidRouteRoute
    }
    '/_default/': {
      id: '/_default/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DefaultIndexRouteImport
      parentRoute: typeof DefaultRouteRoute
    }
    '/$leaid/_error-wrapper/': {
      id: '/$leaid/_error-wrapper/'
      path: '/'
      fullPath: '/$leaid/'
      preLoaderRoute: typeof LeaidErrorWrapperIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/discrepancies': {
      id: '/$leaid/_error-wrapper/discrepancies'
      path: '/discrepancies'
      fullPath: '/$leaid/discrepancies'
      preLoaderRoute: typeof LeaidErrorWrapperDiscrepanciesRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/exports': {
      id: '/$leaid/_error-wrapper/exports'
      path: '/exports'
      fullPath: '/$leaid/exports'
      preLoaderRoute: typeof LeaidErrorWrapperExportsRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/match-tool': {
      id: '/$leaid/_error-wrapper/match-tool'
      path: '/match-tool'
      fullPath: '/$leaid/match-tool'
      preLoaderRoute: typeof LeaidErrorWrapperMatchToolRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/profile': {
      id: '/$leaid/_error-wrapper/profile'
      path: '/profile'
      fullPath: '/$leaid/profile'
      preLoaderRoute: typeof LeaidErrorWrapperProfileRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/upload': {
      id: '/$leaid/_error-wrapper/upload'
      path: '/upload'
      fullPath: '/$leaid/upload'
      preLoaderRoute: typeof LeaidErrorWrapperUploadRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/calpads-sync': {
      id: '/$leaid/_error-wrapper/admin/calpads-sync'
      path: '/admin/calpads-sync'
      fullPath: '/$leaid/admin/calpads-sync'
      preLoaderRoute: typeof LeaidErrorWrapperAdminCalpadsSyncRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/child-data-view': {
      id: '/$leaid/_error-wrapper/admin/child-data-view'
      path: '/admin/child-data-view'
      fullPath: '/$leaid/admin/child-data-view'
      preLoaderRoute: typeof LeaidErrorWrapperAdminChildDataViewRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/lea-data-view': {
      id: '/$leaid/_error-wrapper/admin/lea-data-view'
      path: '/admin/lea-data-view'
      fullPath: '/$leaid/admin/lea-data-view'
      preLoaderRoute: typeof LeaidErrorWrapperAdminLeaDataViewRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/reports': {
      id: '/$leaid/_error-wrapper/admin/reports'
      path: '/admin/reports'
      fullPath: '/$leaid/admin/reports'
      preLoaderRoute: typeof LeaidErrorWrapperAdminReportsRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/state-level-data-view': {
      id: '/$leaid/_error-wrapper/admin/state-level-data-view'
      path: '/admin/state-level-data-view'
      fullPath: '/$leaid/admin/state-level-data-view'
      preLoaderRoute: typeof LeaidErrorWrapperAdminStateLevelDataViewRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/system-messages': {
      id: '/$leaid/_error-wrapper/admin/system-messages'
      path: '/admin/system-messages'
      fullPath: '/$leaid/admin/system-messages'
      preLoaderRoute: typeof LeaidErrorWrapperAdminSystemMessagesRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/certification-cycles/': {
      id: '/$leaid/_error-wrapper/certification-cycles/'
      path: '/certification-cycles'
      fullPath: '/$leaid/certification-cycles/'
      preLoaderRoute: typeof LeaidErrorWrapperCertificationCyclesIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/certification-cycles/$certificationid': {
      id: '/$leaid/_error-wrapper/certification-cycles/$certificationid'
      path: '/certification-cycles/$certificationid'
      fullPath: '/$leaid/certification-cycles/$certificationid'
      preLoaderRoute: typeof LeaidErrorWrapperCertificationCyclesCertificationidRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/mid/': {
      id: '/$leaid/_error-wrapper/mid/'
      path: '/mid'
      fullPath: '/$leaid/mid/'
      preLoaderRoute: typeof LeaidErrorWrapperMidIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/mid/$mid': {
      id: '/$leaid/_error-wrapper/mid/$mid'
      path: '/mid/$mid'
      fullPath: '/$leaid/mid/$mid'
      preLoaderRoute: typeof LeaidErrorWrapperMidMidRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/local-data': {
      id: '/$leaid/_error-wrapper/records/local-data'
      path: '/records/local-data'
      fullPath: '/$leaid/records/local-data'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsLocalDataRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/quick-search': {
      id: '/$leaid/_error-wrapper/records/quick-search'
      path: '/records/quick-search'
      fullPath: '/$leaid/records/quick-search'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsQuickSearchRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/reports/': {
      id: '/$leaid/_error-wrapper/reports/'
      path: '/reports'
      fullPath: '/$leaid/reports/'
      preLoaderRoute: typeof LeaidErrorWrapperReportsIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/reports/$reporttype': {
      id: '/$leaid/_error-wrapper/reports/$reporttype'
      path: '/reports/$reporttype'
      fullPath: '/$leaid/reports/$reporttype'
      preLoaderRoute: typeof LeaidErrorWrapperReportsReporttypeRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/submissions/': {
      id: '/$leaid/_error-wrapper/submissions/'
      path: '/submissions'
      fullPath: '/$leaid/submissions/'
      preLoaderRoute: typeof LeaidErrorWrapperSubmissionsIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/site-administration/anomalies': {
      id: '/$leaid/_error-wrapper/admin/site-administration/anomalies'
      path: '/admin/site-administration/anomalies'
      fullPath: '/$leaid/admin/site-administration/anomalies'
      preLoaderRoute: typeof LeaidErrorWrapperAdminSiteAdministrationAnomaliesRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/site-administration/feature-flags': {
      id: '/$leaid/_error-wrapper/admin/site-administration/feature-flags'
      path: '/admin/site-administration/feature-flags'
      fullPath: '/$leaid/admin/site-administration/feature-flags'
      preLoaderRoute: typeof LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/users/': {
      id: '/$leaid/_error-wrapper/admin/users/'
      path: '/admin/users'
      fullPath: '/$leaid/admin/users/'
      preLoaderRoute: typeof LeaidErrorWrapperAdminUsersIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/admin/users/$userid': {
      id: '/$leaid/_error-wrapper/admin/users/$userid'
      path: '/admin/users/$userid'
      fullPath: '/$leaid/admin/users/$userid'
      preLoaderRoute: typeof LeaidErrorWrapperAdminUsersUseridRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/attendance/': {
      id: '/$leaid/_error-wrapper/records/attendance/'
      path: '/records/attendance'
      fullPath: '/$leaid/records/attendance/'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsAttendanceIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/child/': {
      id: '/$leaid/_error-wrapper/records/child/'
      path: '/records/child'
      fullPath: '/$leaid/records/child/'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsChildIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/child/$entityid': {
      id: '/$leaid/_error-wrapper/records/child/$entityid'
      path: '/records/child/$entityid'
      fullPath: '/$leaid/records/child/$entityid'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsChildEntityidRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/classroom/': {
      id: '/$leaid/_error-wrapper/records/classroom/'
      path: '/records/classroom'
      fullPath: '/$leaid/records/classroom/'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsClassroomIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/classroom/$entityid': {
      id: '/$leaid/_error-wrapper/records/classroom/$entityid'
      path: '/records/classroom/$entityid'
      fullPath: '/$leaid/records/classroom/$entityid'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsClassroomEntityidRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/staff/': {
      id: '/$leaid/_error-wrapper/records/staff/'
      path: '/records/staff'
      fullPath: '/$leaid/records/staff/'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsStaffIndexRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
    '/$leaid/_error-wrapper/records/staff/$staffId': {
      id: '/$leaid/_error-wrapper/records/staff/$staffId'
      path: '/records/staff/$staffId'
      fullPath: '/$leaid/records/staff/$staffId'
      preLoaderRoute: typeof LeaidErrorWrapperRecordsStaffStaffIdRouteImport
      parentRoute: typeof LeaidErrorWrapperRouteRoute
    }
  }
}

interface LeaidErrorWrapperRouteRouteChildren {
  LeaidErrorWrapperDiscrepanciesRoute: typeof LeaidErrorWrapperDiscrepanciesRoute
  LeaidErrorWrapperExportsRoute: typeof LeaidErrorWrapperExportsRoute
  LeaidErrorWrapperMatchToolRoute: typeof LeaidErrorWrapperMatchToolRoute
  LeaidErrorWrapperProfileRoute: typeof LeaidErrorWrapperProfileRoute
  LeaidErrorWrapperUploadRoute: typeof LeaidErrorWrapperUploadRoute
  LeaidErrorWrapperIndexRoute: typeof LeaidErrorWrapperIndexRoute
  LeaidErrorWrapperAdminCalpadsSyncRoute: typeof LeaidErrorWrapperAdminCalpadsSyncRoute
  LeaidErrorWrapperAdminChildDataViewRoute: typeof LeaidErrorWrapperAdminChildDataViewRoute
  LeaidErrorWrapperAdminLeaDataViewRoute: typeof LeaidErrorWrapperAdminLeaDataViewRoute
  LeaidErrorWrapperAdminReportsRoute: typeof LeaidErrorWrapperAdminReportsRoute
  LeaidErrorWrapperAdminStateLevelDataViewRoute: typeof LeaidErrorWrapperAdminStateLevelDataViewRoute
  LeaidErrorWrapperAdminSystemMessagesRoute: typeof LeaidErrorWrapperAdminSystemMessagesRoute
  LeaidErrorWrapperCertificationCyclesCertificationidRoute: typeof LeaidErrorWrapperCertificationCyclesCertificationidRoute
  LeaidErrorWrapperMidMidRoute: typeof LeaidErrorWrapperMidMidRoute
  LeaidErrorWrapperRecordsLocalDataRoute: typeof LeaidErrorWrapperRecordsLocalDataRoute
  LeaidErrorWrapperRecordsQuickSearchRoute: typeof LeaidErrorWrapperRecordsQuickSearchRoute
  LeaidErrorWrapperReportsReporttypeRoute: typeof LeaidErrorWrapperReportsReporttypeRoute
  LeaidErrorWrapperCertificationCyclesIndexRoute: typeof LeaidErrorWrapperCertificationCyclesIndexRoute
  LeaidErrorWrapperMidIndexRoute: typeof LeaidErrorWrapperMidIndexRoute
  LeaidErrorWrapperReportsIndexRoute: typeof LeaidErrorWrapperReportsIndexRoute
  LeaidErrorWrapperSubmissionsIndexRoute: typeof LeaidErrorWrapperSubmissionsIndexRoute
  LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute: typeof LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute
  LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute: typeof LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute
  LeaidErrorWrapperAdminUsersUseridRoute: typeof LeaidErrorWrapperAdminUsersUseridRoute
  LeaidErrorWrapperRecordsChildEntityidRoute: typeof LeaidErrorWrapperRecordsChildEntityidRoute
  LeaidErrorWrapperRecordsClassroomEntityidRoute: typeof LeaidErrorWrapperRecordsClassroomEntityidRoute
  LeaidErrorWrapperRecordsStaffStaffIdRoute: typeof LeaidErrorWrapperRecordsStaffStaffIdRoute
  LeaidErrorWrapperAdminUsersIndexRoute: typeof LeaidErrorWrapperAdminUsersIndexRoute
  LeaidErrorWrapperRecordsAttendanceIndexRoute: typeof LeaidErrorWrapperRecordsAttendanceIndexRoute
  LeaidErrorWrapperRecordsChildIndexRoute: typeof LeaidErrorWrapperRecordsChildIndexRoute
  LeaidErrorWrapperRecordsClassroomIndexRoute: typeof LeaidErrorWrapperRecordsClassroomIndexRoute
  LeaidErrorWrapperRecordsStaffIndexRoute: typeof LeaidErrorWrapperRecordsStaffIndexRoute
}

const LeaidErrorWrapperRouteRouteChildren: LeaidErrorWrapperRouteRouteChildren =
  {
    LeaidErrorWrapperDiscrepanciesRoute: LeaidErrorWrapperDiscrepanciesRoute,
    LeaidErrorWrapperExportsRoute: LeaidErrorWrapperExportsRoute,
    LeaidErrorWrapperMatchToolRoute: LeaidErrorWrapperMatchToolRoute,
    LeaidErrorWrapperProfileRoute: LeaidErrorWrapperProfileRoute,
    LeaidErrorWrapperUploadRoute: LeaidErrorWrapperUploadRoute,
    LeaidErrorWrapperIndexRoute: LeaidErrorWrapperIndexRoute,
    LeaidErrorWrapperAdminCalpadsSyncRoute:
      LeaidErrorWrapperAdminCalpadsSyncRoute,
    LeaidErrorWrapperAdminChildDataViewRoute:
      LeaidErrorWrapperAdminChildDataViewRoute,
    LeaidErrorWrapperAdminLeaDataViewRoute:
      LeaidErrorWrapperAdminLeaDataViewRoute,
    LeaidErrorWrapperAdminReportsRoute: LeaidErrorWrapperAdminReportsRoute,
    LeaidErrorWrapperAdminStateLevelDataViewRoute:
      LeaidErrorWrapperAdminStateLevelDataViewRoute,
    LeaidErrorWrapperAdminSystemMessagesRoute:
      LeaidErrorWrapperAdminSystemMessagesRoute,
    LeaidErrorWrapperCertificationCyclesCertificationidRoute:
      LeaidErrorWrapperCertificationCyclesCertificationidRoute,
    LeaidErrorWrapperMidMidRoute: LeaidErrorWrapperMidMidRoute,
    LeaidErrorWrapperRecordsLocalDataRoute:
      LeaidErrorWrapperRecordsLocalDataRoute,
    LeaidErrorWrapperRecordsQuickSearchRoute:
      LeaidErrorWrapperRecordsQuickSearchRoute,
    LeaidErrorWrapperReportsReporttypeRoute:
      LeaidErrorWrapperReportsReporttypeRoute,
    LeaidErrorWrapperCertificationCyclesIndexRoute:
      LeaidErrorWrapperCertificationCyclesIndexRoute,
    LeaidErrorWrapperMidIndexRoute: LeaidErrorWrapperMidIndexRoute,
    LeaidErrorWrapperReportsIndexRoute: LeaidErrorWrapperReportsIndexRoute,
    LeaidErrorWrapperSubmissionsIndexRoute:
      LeaidErrorWrapperSubmissionsIndexRoute,
    LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute:
      LeaidErrorWrapperAdminSiteAdministrationAnomaliesRoute,
    LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute:
      LeaidErrorWrapperAdminSiteAdministrationFeatureFlagsRoute,
    LeaidErrorWrapperAdminUsersUseridRoute:
      LeaidErrorWrapperAdminUsersUseridRoute,
    LeaidErrorWrapperRecordsChildEntityidRoute:
      LeaidErrorWrapperRecordsChildEntityidRoute,
    LeaidErrorWrapperRecordsClassroomEntityidRoute:
      LeaidErrorWrapperRecordsClassroomEntityidRoute,
    LeaidErrorWrapperRecordsStaffStaffIdRoute:
      LeaidErrorWrapperRecordsStaffStaffIdRoute,
    LeaidErrorWrapperAdminUsersIndexRoute:
      LeaidErrorWrapperAdminUsersIndexRoute,
    LeaidErrorWrapperRecordsAttendanceIndexRoute:
      LeaidErrorWrapperRecordsAttendanceIndexRoute,
    LeaidErrorWrapperRecordsChildIndexRoute:
      LeaidErrorWrapperRecordsChildIndexRoute,
    LeaidErrorWrapperRecordsClassroomIndexRoute:
      LeaidErrorWrapperRecordsClassroomIndexRoute,
    LeaidErrorWrapperRecordsStaffIndexRoute:
      LeaidErrorWrapperRecordsStaffIndexRoute,
  }

const LeaidErrorWrapperRouteRouteWithChildren =
  LeaidErrorWrapperRouteRoute._addFileChildren(
    LeaidErrorWrapperRouteRouteChildren,
  )

interface LeaidRouteRouteChildren {
  LeaidErrorWrapperRouteRoute: typeof LeaidErrorWrapperRouteRouteWithChildren
}

const LeaidRouteRouteChildren: LeaidRouteRouteChildren = {
  LeaidErrorWrapperRouteRoute: LeaidErrorWrapperRouteRouteWithChildren,
}

const LeaidRouteRouteWithChildren = LeaidRouteRoute._addFileChildren(
  LeaidRouteRouteChildren,
)

interface DefaultRouteRouteChildren {
  DefaultIndexRoute: typeof DefaultIndexRoute
}

const DefaultRouteRouteChildren: DefaultRouteRouteChildren = {
  DefaultIndexRoute: DefaultIndexRoute,
}

const DefaultRouteRouteWithChildren = DefaultRouteRoute._addFileChildren(
  DefaultRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LeaidRouteRoute: LeaidRouteRouteWithChildren,
  DefaultRouteRoute: DefaultRouteRouteWithChildren,
  TermsConditionsRoute: TermsConditionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
